import { render } from "./FacilitiesIAReview.vue?vue&type=template&id=50089130"
import script from "./FacilitiesIAReview.vue?vue&type=script&lang=js"
export * from "./FacilitiesIAReview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__